import React, { memo, useContext, useEffect, useState, useRef } from "react";
import { Form } from "react-bootstrap";
import { callAPI } from "../../helper/apiUtils";
import ShareProjectMapDialog from "../../components/ProjectMapShare/ShareProjectMapDialog";
import LanguageContext from "../../helper/LanguageContext";
import { $crud } from "../../helper/CrudFactory";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { Scrollbars } from "react-custom-scrollbars";
import { connect, useDispatch, useSelector } from "react-redux";
import { BsArrowLeft, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { IoIosNotificationsOutline } from "react-icons/io";
import {
  OPEN_BOTTOM_PROJECTS,
  OPEN_PROJECTS,
  PROJECT_REQUEST_COUNT,
  PROJECTS,
  UPDATE_PROJECT_ACTION_FIRE,
  IS_OPEN_BY_OWNER,
  ALL_BADGE_COUNT,
  INTERNAL_PROJECTS,
  SET_JOIN_REQUEST_EXTERNAL,
  SET_TAB,
  SET_JOIN_REQUEST_INTERNAL,
  SET_COMPANY_IMAGE,
  SET_COMPANY_ID,
  RESET_MARKIN_PROJECT,
  TOGGLE_PROJECT,
  TOGGLE_LATEST_MSG,
  SET_DEEPLINK_LOADING,
  SET_DEEPLINK_DATA,
  SET_OVERSIGHT_ROOM,
} from "../../store";
import { Link, withRouter } from "react-router-dom";
import ProjectNotification from "./ProjectNotification";
import CompanyListDialog from "./Dialogs/CompanyListDialog";
import { getLightColor, KJUUP_COLORS, TOGGLE_DRAWER, getAvatarInitials } from "../../helper/constants";
import ProjectListComponent from "./ProjectListComponent";
import PropTypes, { element } from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import ProjectListComponentInternal from "./ProjectListComponentInternal";
import IGRENN from '../../Icons/InternalGreen.png';
import INormal from '../../Icons/Internal-Project.png';
import ExternalOrange from '../../Icons/ExternalOrange.png';
import ExternalNormal from '../../Icons/External-Project.png';
import { SocketContext } from "../../context/socket";
import { ReactComponent as AddProjectIcon } from '../../Icons/Add project-deactivated.svg';
import CommonHeader from "../../components/CommonHeader";
import { useHistory } from "react-router-dom";
import InvitationProjectsCard from "../../components/InvitationProjectsCard";
import CompanySelector from "../../components/CompanySelector";
import AddProject from "./AddProject";
import OversightRoomList from "./OversightRoomList";
import SectionHeader from "./RoomSectionHeader";
import { cachedMyCompanies, fetchMyCompanies, managesCompanyRooms } from "../../utils/roomOversight";
import { roomUnreadCount } from "./roomDnd";
import { orderActiveRooms, sortByActivity, withoutListFields } from "./roomOrder";
import { shouldShowDailyBriefingCounters } from "../../utils/dailyBriefingCounters";
// CircularProgress removed - using skeleton loader instead
import { FaChevronRight } from "react-icons/fa";
import "./MyProject.css";

function a11yProps(index, value) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    style: {
      // backgroundColor: (index == 0 && value == index) ? "yellow" : (index == 1 && value == index) ? "blue" : "white",
      color: (index == 1 && value == index) ? "var(--kjuup-internal)" : (index == 0 && value == index) ? "var(--kjuup-accent)" : "grey",
      borderWidth: 0,
      padding: 0,
      textTransform: "none",
      fontSize: "1.8vh",
      bottom: 7,
      // fontWeight: "200"
    }
  };
}


const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const hideHorizontalTrack = () => <div style={{ display: 'none' }} />;

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    renderTrackHorizontal={hideHorizontalTrack}
    {...props}
  />
);

const ROOM_SECTION_KEYS = {
  DEACTIVATED: 'deactivated_rooms',
  COMPLETED: 'completed_rooms',
};

const OVERSIGHT_TAB = 2;
// Every room of the user in one list: external and the internal rooms of all
// companies. External / Internal / Oversight only filter it.
const ALL_TAB = -1;

// Which room tabs the user had last time, remembered per user so the header
// renders Extern/Intern/Oversight on the first frame, even after a reload,
// instead of popping them in once the lists answer.
const ROOM_TABS_HINT_KEY = "kj_room_tabs_hint";
function readRoomTabsHint(userId) {
  try {
    const hint = JSON.parse(localStorage.getItem(ROOM_TABS_HINT_KEY) || "null");
    return hint && userId != null && String(hint.userId) === String(userId) ? hint : {};
  } catch (e) {
    return {};
  }
}
function writeRoomTabsHint(userId, patch) {
  if (userId == null) return;
  try {
    const next = { ...readRoomTabsHint(userId), ...patch, userId };
    localStorage.setItem(ROOM_TABS_HINT_KEY, JSON.stringify(next));
  } catch (e) { }
}

function MyProject(props) {


  const [params, setParams] = useState({
    companyId: "",
    id: "",
    companySelect: false,
  });
  const [value, setValue] = React.useState(0);
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [show, setShow] = useState(false);
  const [projectDetails, setProjectDetails] = useState({});
  const cachedRoomList = (props.projects && props.projects.length > 0) ? props.projects : [];
  const [allProjects, setAllProject] = useState(cachedRoomList);
  const [projects, setProjects] = useState(cachedRoomList);
  const [PlusProject, setKjuupPlusProjects] = useState([]);
  const [PlusProjectAll, setAllKjuupPlusProjects] = useState([]);
  const [showCompanyDialog, setCompanyDialog] = useState(false);
  const loginToken = useSelector(state => state.userLoginToken);
  const [companies, setCompanies] = useState(() => cachedMyCompanies(loginToken));
  const [search, setSearch] = useState("");
  const [pendingRequests, setPendingRequests] = useState([]);
  const [pendingRequestsPlus, setPendingRequestsPlus] = useState([]);
  const [showNotification, setNotification] = useState(false);
  const [plusNotifications, setPlusNotifications] = useState(false);
  const joinRequestsInternal = useSelector(state => state.joinRequestsInternal)
  const joinRequestsExternal = useSelector(state => state.joinRequestsExternal)
  const selectedCompanyId = useSelector(state => state.selectedCompanyId)
  const { unSeenAllCount } = useSelector((state) => state);
  // Seeded from the store so a return visit shows the Extern/Intern tabs on
  // the first frame instead of after /building/internalProjects answers.
  const user = useSelector((state) => state.user);
  const userId = user?.id ?? user?._id;
  const [roomTabsHint] = useState(() => readRoomTabsHint(userId));
  const storedInternalProjects = useSelector(e => e.internalProjectsAll)
  const [internalProkjects, setInternalProjects] = useState(() => storedInternalProjects || []);
  const [shouldShowTabWise, setShouldShowTabWise] = useState(() =>
    (storedInternalProjects?.length || 0) > 0 || !!roomTabsHint.internal
  );
  // Until these answer, the hint decides; afterwards the real data does.
  const internalLoadedRef = useRef(false);
  const [companiesLoaded, setCompaniesLoaded] = useState(() => companies.length > 0);
  const Socket = useContext(SocketContext);
  const profile = useSelector((state) => state.profile);
  const subscription = useSelector((state) => state.subscription);
  const showDailyBriefingCounters = shouldShowDailyBriefingCounters(user, profile, subscription);
  const [disableProjet, setDisableProject] = useState(false)
  const hasInitialFetchedJoinRequests = useRef(false);
  const history = useHistory();
  const [showAddProject, setShowAddProject] = useState(false)
  // Oversight stays local: the shared SET_TAB value only knows extern/intern.
  const [oversight, setOversight] = useState(false)
  const [oversightCompanyId, setOversightCompanyId] = useState(null)
  // The combined list ("All") is the default; Supervision (oversight) replaces
  // it. Local like `oversight`: SET_TAB stays extern/intern.
  const [showAll, setShowAll] = useState(true)
  const pinnedRooms = useSelector(state => state.pinnedRooms)
  const [isLoading, setIsLoading] = useState(cachedRoomList.length === 0);
  const [showSkeleton, setShowSkeleton] = useState(cachedRoomList.length === 0);
  const [isContentReady, setIsContentReady] = useState(cachedRoomList.length > 0);
  const deeplinkData = useSelector(state => state.deeplinkData)
  const isDesktop = useSelector(state => state.isDeskTopResolution)
  
  // Add refs to prevent duplicate API calls
  const isFetchingProjects = useRef(false);
  const isFetchingInternalProjects = useRef(false);

  // Collapsible section state — keys must stay language-independent
  const [expandedSections, setExpandedSections] = useState({
    [ROOM_SECTION_KEYS.DEACTIVATED]: false,
    [ROOM_SECTION_KEYS.COMPLETED]: false,
  });

  const [expandedSectionsInternal, setExpandedSectionsInternal] = useState({
    [ROOM_SECTION_KEYS.DEACTIVATED]: false,
    [ROOM_SECTION_KEYS.COMPLETED]: false,
  });

  const [expandedSectionsAll, setExpandedSectionsAll] = useState({
    [ROOM_SECTION_KEYS.DEACTIVATED]: false,
    [ROOM_SECTION_KEYS.COMPLETED]: false,
  });

  const sectionUnread = (rooms) =>
    (rooms || []).reduce(
      (sum, room) => sum + roomUnreadCount(room, showDailyBriefingCounters),
      0
    );

  useEffect(() => {
    const completed = sectionUnread(projects.filter((item) => item.isDone));
    const deactivated = sectionUnread(projects.filter((item) => !item.isJoin && !item.isDone));
    if (!completed && !deactivated) return;
    setExpandedSections((prev) => ({
      ...prev,
      [ROOM_SECTION_KEYS.COMPLETED]: prev[ROOM_SECTION_KEYS.COMPLETED] || completed > 0,
      [ROOM_SECTION_KEYS.DEACTIVATED]: prev[ROOM_SECTION_KEYS.DEACTIVATED] || deactivated > 0,
    }));
  }, [projects, showDailyBriefingCounters]);

  useEffect(() => {
    const selected = PlusProject.find((c) => c.isSelected);
    const list = selected?.userProjectList || [];
    const completed = sectionUnread(list.filter((item) => item.isDone));
    const deactivated = sectionUnread(list.filter((item) => !item.isJoin && !item.isDone));
    if (!completed && !deactivated) return;
    setExpandedSectionsInternal((prev) => ({
      ...prev,
      [ROOM_SECTION_KEYS.COMPLETED]: prev[ROOM_SECTION_KEYS.COMPLETED] || completed > 0,
      [ROOM_SECTION_KEYS.DEACTIVATED]: prev[ROOM_SECTION_KEYS.DEACTIVATED] || deactivated > 0,
    }));
  }, [PlusProject, showDailyBriefingCounters]);

  // "All": the external rooms and the internal rooms of every company, one
  // entry per room. An internal row keeps its company (open, re-join, leave).
  const allRooms = React.useMemo(() => {
    const seenRooms = new Set();
    const seenCompanies = new Set();
    const out = [];
    const add = (room, extra) => {
      if (!room || room.id == null) return;
      const key = String(room.id);
      if (seenRooms.has(key)) return;
      seenRooms.add(key);
      out.push({ ...room, ...extra });
    };
    (allProjects || []).forEach((room) => add(room, { listKind: "external" }));
    (internalProkjects || []).forEach((company) => {
      if (!company || seenCompanies.has(company.id)) return;
      seenCompanies.add(company.id);
      (company.userProjectList || []).forEach((room) => add(room, { listKind: "internal", listCompany: company }));
    });
    return out;
  }, [allProjects, internalProkjects]);

  useEffect(() => {
    const completed = sectionUnread(allRooms.filter((item) => item.isDone));
    const deactivated = sectionUnread(allRooms.filter((item) => !item.isJoin && !item.isDone));
    if (!completed && !deactivated) return;
    setExpandedSectionsAll((prev) => ({
      ...prev,
      [ROOM_SECTION_KEYS.COMPLETED]: prev[ROOM_SECTION_KEYS.COMPLETED] || completed > 0,
      [ROOM_SECTION_KEYS.DEACTIVATED]: prev[ROOM_SECTION_KEYS.DEACTIVATED] || deactivated > 0,
    }));
  }, [allRooms, showDailyBriefingCounters]);

  useEffect(() => {
    if (Socket && Socket.on) {
      _addRemoveProjectListener()
    }
  }, [Socket])

  // Track retry attempts for internal room opening
  const internalRoomRetryRef = useRef(0);
  const internalRoomRetryTimeoutRef = useRef(null);

  // Guard ref to prevent processing the same deeplink multiple times
  // Stores the roomId that has been processed so re-renders don't re-trigger
  const processedDeeplinkRef = useRef(null);

  // Reset the guard when deeplinkData is cleared (by ProjectDetail or timeout)
  useEffect(() => {
    if (!deeplinkData) {
      processedDeeplinkRef.current = null;
      internalRoomRetryRef.current = 0;
    }
  }, [deeplinkData]);

  // Handle external room opening when deeplinkData or projects change
  useEffect(() => {
    if (deeplinkData && !deeplinkData.isInternal && projects.length > 0) {
      const { roomId } = deeplinkData;
      const deeplinkKey = `ext-${roomId}`;

      // Skip if we already processed this exact deeplink (or it was processed as internal fallback)
      if (processedDeeplinkRef.current === deeplinkKey || processedDeeplinkRef.current === `int-${roomId}`) return;

      console.log('[MyProject] External room deeplink - roomId:', roomId, 'projects count:', projects.length);

      if (roomId) {
        const findProject = projects.find(e =>
          e.id && roomId &&
          e.id.toString() === roomId.toString()
        );
        if (findProject) {
          // Activate external section
          setValue(0);
          props.changeTab(0);

          const isAlreadyOpen = props.openProjects.find(e =>
            e.id && roomId &&
            e.id.toString() === roomId.toString()
          );
          if (!isAlreadyOpen) {
            console.log('[MyProject] Opening external room:', findProject.name || findProject.id);
            processedDeeplinkRef.current = deeplinkKey;
            chat_click(true, findProject);
          } else {
            // Room already open - dismiss loader
            console.log('[MyProject] External room already open, dismissing loader');
            dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
            dispatch({ type: SET_DEEPLINK_DATA, payload: null });
          }
        } else {
          // Room not found in external projects - try internal as fallback
          if (!deeplinkData._triedInternal) {
            console.log('[MyProject] Room not found in external projects, trying internal fallback. roomId:', roomId);
            dispatch({ type: SET_DEEPLINK_DATA, payload: { ...deeplinkData, isInternal: true, _triedExternal: true } });
          } else {
            // Already tried both sections - give up
            console.log('[MyProject] Room not found in either section, dismissing loader. roomId:', roomId);
            dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
            dispatch({ type: SET_DEEPLINK_DATA, payload: null });
          }
        }
      }
    }
  }, [projects, deeplinkData])

  // Handle internal project room opening when deeplinkData or PlusProject changes
  useEffect(() => {
    if (deeplinkData && deeplinkData.isInternal) {
      const { roomId, companyId } = deeplinkData;
      const deeplinkKey = `int-${roomId}`;

      // Skip if we already processed this exact deeplink (or it was processed by external handler)
      if (processedDeeplinkRef.current === deeplinkKey || processedDeeplinkRef.current === `ext-${roomId}`) return;

      console.log('[MyProject] Internal room deeplink - roomId:', roomId, 'companyId:', companyId, 'PlusProject count:', PlusProject.length);

      // Activate internal section
      setValue(1);
      props.changeTab(1);

      // If PlusProject is empty, trigger load - data will flow via Redux -> internalProkjects -> PlusProject
      if (PlusProject.length === 0) {
        console.log('[MyProject] PlusProject empty, triggering load...');
        getKjuupPlusProjects();
        return;
      }

      if (roomId) {
        // Find the company - use companyId if available, otherwise search all companies for the room
        let companyIndex = -1;
        let roomIndex = -1;

        if (companyId) {
          companyIndex = PlusProject.findIndex(e => e.id && e.id.toString() === companyId.toString());
          if (companyIndex !== -1 && PlusProject[companyIndex]) {
            const roomsOfCompany = PlusProject[companyIndex].userProjectList || [];
            roomIndex = roomsOfCompany.findIndex(e =>
              (e.id && e.id.toString() === roomId.toString()) ||
              (e.building && e.building.toString() === roomId.toString())
            );
          }
        }

        // Fallback: search all companies for the room if companyId missing or room not found
        if (roomIndex === -1) {
          for (let i = 0; i < PlusProject.length; i++) {
            const roomsOfCompany = PlusProject[i].userProjectList || [];
            const idx = roomsOfCompany.findIndex(e =>
              (e.id && e.id.toString() === roomId.toString()) ||
              (e.building && e.building.toString() === roomId.toString())
            );
            if (idx !== -1) {
              companyIndex = i;
              roomIndex = idx;
              break;
            }
          }
        }

        console.log('[MyProject] Internal lookup result - companyIndex:', companyIndex, 'roomIndex:', roomIndex);

        if (companyIndex !== -1 && PlusProject[companyIndex]) {
          const company = PlusProject[companyIndex];
          const roomsOfCompany = company.userProjectList || [];
          const isAlreadyOpen = props.openProjects.find(e => e.id && e.id.toString() === roomId.toString());

          if (roomIndex !== -1 && !isAlreadyOpen) {
            // Room found - mark as processed, select company, and open room
            console.log('[MyProject] Opening internal room:', roomsOfCompany[roomIndex].name || roomsOfCompany[roomIndex].id, 'in company:', company.name || company.id);
            processedDeeplinkRef.current = deeplinkKey;
            internalRoomRetryRef.current = 0;

            // Select the correct company so the UI shows the right company's rooms
            const updatedPlusProject = PlusProject.map((c, i) => ({ ...c, isSelected: i === companyIndex }));
            setKjuupPlusProjects(updatedPlusProject);
            setAllKjuupPlusProjects(updatedPlusProject);

            // Sync company selection in Redux for proper UI state
            dispatch({ type: SET_COMPANY_ID, payload: company.id });
            dispatch({ type: SET_COMPANY_IMAGE, payload: { logo: company.logo || null, name: company.name || null } });

            // Open the room
            chat_click_plus(0, roomsOfCompany[roomIndex], 1, company.videoCallEnabled);
          } else if (roomIndex !== -1 && isAlreadyOpen) {
            // Room already open - dismiss loader
            console.log('[MyProject] Internal room already open, dismissing loader');
            dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
            dispatch({ type: SET_DEEPLINK_DATA, payload: null });
          } else if (roomIndex === -1 && internalRoomRetryRef.current < 3) {
            // Room not found in this company - retry after refreshing projects
            internalRoomRetryRef.current += 1;
            console.log('[MyProject] Internal room not found, retry', internalRoomRetryRef.current);
            if (internalRoomRetryTimeoutRef.current) {
              clearTimeout(internalRoomRetryTimeoutRef.current);
            }
            internalRoomRetryTimeoutRef.current = setTimeout(() => {
              let ind = PlusProject.findIndex(e => e.isSelected);
              getKjuupPlusProjects(ind);
            }, 1000);
          } else if (roomIndex === -1 && internalRoomRetryRef.current >= 3) {
            // Room not found after retries in internal - try external as fallback
            if (!deeplinkData._triedExternal) {
              console.log('[MyProject] Internal room not found after retries, trying external fallback');
              dispatch({ type: SET_DEEPLINK_DATA, payload: { ...deeplinkData, isInternal: false, _triedInternal: true } });
            } else {
              console.log('[MyProject] Room not found in either section, dismissing loader');
              dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
              dispatch({ type: SET_DEEPLINK_DATA, payload: null });
            }
          }
        } else {
          // Company/room not found in any company
          if (internalRoomRetryRef.current < 3) {
            internalRoomRetryRef.current += 1;
            console.log('[MyProject] Room not found in any company, retry', internalRoomRetryRef.current);
            if (internalRoomRetryTimeoutRef.current) {
              clearTimeout(internalRoomRetryTimeoutRef.current);
            }
            internalRoomRetryTimeoutRef.current = setTimeout(() => {
              getKjuupPlusProjects();
            }, 1000);
          } else {
            // Exhausted retries - try external as fallback
            if (!deeplinkData._triedExternal) {
              console.log('[MyProject] Room not found in internal after retries, trying external fallback');
              dispatch({ type: SET_DEEPLINK_DATA, payload: { ...deeplinkData, isInternal: false, _triedInternal: true } });
            } else {
              console.log('[MyProject] Room not found in either section, dismissing loader');
              dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
              dispatch({ type: SET_DEEPLINK_DATA, payload: null });
            }
          }
        }
      }
    }
    // Cleanup timeout on unmount
    return () => {
      if (internalRoomRetryTimeoutRef.current) {
        clearTimeout(internalRoomRetryTimeoutRef.current);
      }
    };
  }, [PlusProject, deeplinkData])

  const chat_click_plus = async (value, row, lemp, videoCallEnabled) => {
    const project = withoutListFields(row);
    dispatch({ type: TOGGLE_PROJECT, payload: true })
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
    props.isOwnerOpenProject(false);
    const opened = { ...project, isInternal: true, videoCallEnabled, isOpened: true, viewByOwner: false };
    props.updateOpenProjects([opened]);
    const updateGroup = (projects || []).map((p) => (
      p.id && project.id && p.id.toString() === project.id.toString()
        ? { ...p, isOpened: true, viewByOwner: false, isInternal: true, videoCallEnabled }
        // The other rows are external rooms: only drop their highlight, so a
        // pinned external room does not open as internal afterwards.
        : { ...p, isOpened: false }
    ));
    setAllProject(updateGroup);
    setProjects(updateGroup);
    props.updateProjects(updateGroup);
  };

  const chat_click = async (value, row) => {
    const project = withoutListFields(row);
    dispatch({ type: TOGGLE_PROJECT, payload: true })
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false })
    props.isOwnerOpenProject(false);
    const opened = { ...project, isInternal: false, isOpened: true, viewByOwner: false };
    props.updateOpenProjects([opened]);
    const updateGroup = (projects || []).map((p) => (
      p.id && project.id && p.id.toString() === project.id.toString()
        ? { ...p, isOpened: true, viewByOwner: false, isInternal: false }
        : { ...p, isInternal: false, isOpened: false }
    ));
    setAllProject(updateGroup);
    setProjects(updateGroup);
    props.updateProjects(updateGroup);
  };

  const _addRemoveProjectListener = () => {
    Socket.on('leaveCompany', function (mdata) {
      setDisableProject(mdata)
    });
  }

  const internalProjectsAll = useSelector(e => e.internalProjectsAll)
  const dispatch = useDispatch()
  useEffect(() => {
    console.log('---------->reset mark', props.resetProjectMarking)
    // if (props.resetProjectMarking) {
    let tmp = projects.map((e) => {
      return { ...e, isOpened: false }
    })
    let tmp2 = PlusProject.map((e) => {
      return { ...e, isOpened: false }
    })
    setProjects(tmp)
    setKjuupPlusProjects(tmp2)
    setAllKjuupPlusProjects(tmp2)
    setAllProject(tmp)
    // }
    props.resetMarking(false)
  }, [props.resetProjectMarking])
  useEffect(() => {
    console.log('--------------Join External', joinRequestsExternal)
    setPendingRequests(joinRequestsExternal)
    _ttm()
  }, [joinRequestsExternal])
  useEffect(() => {
    setPendingRequestsPlus(joinRequestsInternal)
    if (joinRequestsInternal && joinRequestsInternal.length > 0 && value === 1 && !showAll) {
      setPlusNotifications(true)
    }
  }, [joinRequestsInternal])
  useEffect(() => {
    if (value === 1 && !showAll && pendingRequestsPlus && pendingRequestsPlus.length > 0) {
      setPlusNotifications(true)
    }
  }, [value, showAll])
  const { userLoginToken } = useSelector((state) => state);
  const getCompanies = async () => {
    if (userLoginToken) {
      // Through the shared cache, which the Messages oversight entry reads too.
      const list = await fetchMyCompanies(userLoginToken);
      if (list) {
        setCompanies(list);
        setCompaniesLoaded(true);
        writeRoomTabsHint(userId, { oversight: list.some(managesCompanyRooms) });
      }
    }
  };
  const getProjectJoinRequest = async (internalRequestIds = new Set()) => {
    if (userLoginToken) {
      const { data } = await callAPI(
        `/building/getProjectJoinRequest`,
        {},
        "GET"
      );
      const internalIdsArray = Array.from(internalRequestIds);
      console.log('getProjectJoinRequest API response:', data);
      console.log('Internal request IDs to exclude (count: ' + internalIdsArray.length + '):', internalIdsArray);
      if (data.status) {
        // Filter to only include EXTERNAL requests
        // Exclude any request that exists in internal requests
        const requestMap = new Map();
        
        (data.requests || []).forEach(req => {
          const requestId = req?.requestId;
          const reqId = req?.id; // Also check 'id' field
          
          // Check if this request is in the internal set (check both requestId and id)
          const isInternalByRequestId = requestId && (
            internalRequestIds.has(requestId) || 
            internalRequestIds.has(String(requestId))
          );
          const isInternalById = reqId && (
            internalRequestIds.has(reqId) || 
            internalRequestIds.has(String(reqId))
          );
          const isInternalRequest = isInternalByRequestId || isInternalById;
          
          console.log('Request object:', JSON.stringify(req));
          console.log('Request:', requestId, 'id:', reqId, 'isInternalRequest:', isInternalRequest);
          
          // Only add if NOT an internal request
          const uniqueKey = requestId || reqId;
          if (uniqueKey && !requestMap.has(uniqueKey) && !isInternalRequest) {
            requestMap.set(uniqueKey, req);
          }
        });
        
        const externalRequests = Array.from(requestMap.values());
        console.log('External requests count after filtering:', externalRequests.length, externalRequests.map(r => r.requestId));
        dispatch({ type: SET_JOIN_REQUEST_EXTERNAL, requests: externalRequests });
        props.updateProjectRequestCount(externalRequests.length);
      }
    }
  };
  const setParam = async (name, value) => {
    setParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    if (PlusProject && PlusProject.length > 0 && selectedCompanyId) {
      console.log('==================>compiiiid', selectedCompanyId)
      // First deduplicate in case there are any duplicates
      let dedupedProjects = deduplicateCompanies(PlusProject);
      let filteredArticles = dedupedProjects.map((e, i) => {
        if (selectedCompanyId !== null)
          return { ...e, isSelected: (e.id == selectedCompanyId) ? true : false }
        else
          return { ...e, isSelected: i == 0 ? true : false }
      })
      let ind = filteredArticles.findIndex(e => e.isSelected)
      // No longer need to scroll since CompanySelector uses button layout
      setKjuupPlusProjects([...filteredArticles])
      setAllKjuupPlusProjects([...filteredArticles])
    }
  }, [selectedCompanyId])

  const _ttm = () => {

  }

  // Helper function to deduplicate companies by ID
  const deduplicateCompanies = (companies) => {
    const uniqueCompanies = [];
    const seenIds = new Set();
    for (const company of companies) {
      if (!seenIds.has(company.id)) {
        seenIds.add(company.id);
        uniqueCompanies.push(company);
      }
    }
    return uniqueCompanies;
  };

  const handleShow = async (project) => {
    setShow(true);
    setProjectDetails(project);
  };
  const handleClose = () => setShow(false);

  const revealRoomList = () => {
    setIsLoading(false);
    setShowSkeleton(false);
    setIsContentReady(true);
  };
  const skipNextRoomRefreshRef = useRef(false);

  useEffect(() => {
    if (userLoginToken) {
      // Reset the fetch flag when token changes (e.g., on login)
      hasInitialFetchedJoinRequests.current = false;
      // Alle Räume sets updateProjectAction in the same click that mounts
      // this screen. Skip that extra refresh so it does not run beside the
      // first load.
      if (props.updateProjectActionFire) skipNextRoomRefreshRef.current = true;

      const cachedRooms = props.projects && props.projects.length > 0;
      if (cachedRooms) {
        setProjects(props.projects);
        setAllProject(props.projects);
        revealRoomList();
      } else {
        setIsLoading(true);
        setShowSkeleton(true);
        setIsContentReady(false);
      }
      // All three load in parallel: the Extern/Intern/Oversight tabs depend
      // on the internal list and the company list, so chaining them behind
      // the visible list left the header without tabs for seconds.
      const showInternal = props.isExternalSelected === 1;
      const primary = showInternal ? getKjuupPlusProjects() : getProjects();
      if (showInternal) getProjects();
      else getKjuupPlusProjects();
      getCompanies().catch(console.error);
      primary.finally(revealRoomList);
    }
  }, [userLoginToken]);

  const getProjects = async () => {
    // Prevent duplicate API calls
    if (isFetchingProjects.current) {
      console.log('[MyProject] Skipping duplicate /building/my API call');
      return;
    }
    
    try {
      if (userLoginToken) {
        isFetchingProjects.current = true;
        const { data } = await callAPI("/building/my", {}, "GET");
        if (data.status) {
          let sortData = await data.buildings.map((building, i) => {
            return { ...building, key: i + 1, isOpened: false };
          });
          const updateGroup = sortData.map((g) => {
            const chk = props.openProjects.find((c) => c.id === g.id);
            if (chk) {
              return { ...g, isOpened: true };
            } else {
              return { ...g };
            }
          });
          setAllProject(updateGroup);
          setProjects(updateGroup);
          props.updateProjects(updateGroup);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      isFetchingProjects.current = false;
    }
  };

  const getKjuupPlusProjects = async (ind) => {
    // Prevent duplicate API calls
    if (isFetchingInternalProjects.current) {
      console.log('[MyProject] Skipping duplicate /building/internalProjects API call');
      return;
    }
    
    try {
      if (userLoginToken) {
        isFetchingInternalProjects.current = true;
        let chatGroupId, roomId, companyId;
        if (deeplinkData) {
          ({ chatGroupId, roomId, companyId } = deeplinkData);
        }
        const { data } = await callAPI("/building/internalProjects", {}, "GET");
        if (data.status) {
          let all = [...data.foundUserCompany];
          internalLoadedRef.current = true;
          writeRoomTabsHint(userId, { internal: all.length > 0 });
          // An empty answer leaves the store untouched, so drop the hinted tabs here.
          if (all.length === 0) setShouldShowTabWise(false);
          if (all.length > 0) {
            let _all = [...all];
            let filteredArticles = _all.map((e, i) => {
              if (selectedCompanyId !== null || companyId)
                return { ...e, isSelected: (e.id == selectedCompanyId || e.id == companyId) ? true : false }
              else
                return { ...e, isSelected: i == 0 ? true : false }
            });
            let ind = filteredArticles.findIndex(e => e.isSelected);
            // No longer need to scroll since CompanySelector uses button layout
            props.updateProjectsInternal(filteredArticles);
            // NOTE: Room opening for deeplinks is handled by the [PlusProject, deeplinkData] useEffect
            // to prevent duplicate room opening. Company pre-selection is already handled above
            // in the filteredArticles mapping using companyId from deeplinkData.
            if (deeplinkData && deeplinkData.isInternal) {
              setValue(1);
              props.changeTab(1);
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      isFetchingInternalProjects.current = false;
    }
  };

  useEffect(() => {
    if (internalProkjects && internalProkjects.length && internalProkjects.length > 0) {
      setShouldShowTabWise(true)
      let all = [...internalProkjects]
      
      // Deduplicate companies by ID to prevent duplicate tabs
      all = deduplicateCompanies(all);
      
      // During internal deeplink navigation, preserve the company selection that was
      // set by the deeplink effect. Without this, getKjuupPlusProjects response would
      // overwrite PlusProject with the wrong company selected (e.g. selectedCompanyId
      // from before the deeplink, or default first company).
      if (processedDeeplinkRef.current && processedDeeplinkRef.current.startsWith('int-') && PlusProject.length > 0) {
        const currentlySelected = PlusProject.find(e => e.isSelected);
        if (currentlySelected) {
          console.log('[MyProject] Preserving deeplink company selection:', currentlySelected.id, currentlySelected.name);
          all = all.map(e => ({ ...e, isSelected: e.id === currentlySelected.id }));
        }
      }

      setKjuupPlusProjects(all)
      setAllKjuupPlusProjects(all)
    }
    else if (internalLoadedRef.current) {
      setShouldShowTabWise(false)
    }
  }, [internalProkjects])


  useEffect(() => {
    // Fetch internal join requests for ALL companies to get accurate counter
    // Only run ONCE on initial load to prevent re-fetching when PlusProject updates
    if (PlusProject.length > 0 && !hasInitialFetchedJoinRequests.current) {
      hasInitialFetchedJoinRequests.current = true;
      
      const fetchAllInternalRequests = async () => {
        // Collect all internal request IDs
        const allInternalRequestIds = new Set();
        const updatedPlusProject = [...PlusProject];
        
        for (let index = 0; index < updatedPlusProject.length; index++) {
          const company = updatedPlusProject[index];
          if (!company.projectJoinRequests) {
            const { data } = await callAPI(`/building/getProjectJoinRequest?companyId=${company.id}`, {}, "GET");
            console.log('getInternalJoinRequest API response for company', company.id, ':', data);
            if (data.status) {
              let req = []
              for (let obj of data.requests) {
                let x = { ...obj, cId: company.id }
                req.push(x)
                // Add both requestId and id to the set to handle different field names
                if (obj.requestId) {
                  allInternalRequestIds.add(obj.requestId);
                  allInternalRequestIds.add(String(obj.requestId));
                }
                if (obj.id) {
                  allInternalRequestIds.add(obj.id);
                  allInternalRequestIds.add(String(obj.id));
                }
              }
              updatedPlusProject[index] = { ...updatedPlusProject[index], projectJoinRequests: [...req] };
            }
          } else {
            // Already have requests, just collect their IDs
            company.projectJoinRequests.forEach(req => {
              if (req.requestId) {
                allInternalRequestIds.add(req.requestId);
                allInternalRequestIds.add(String(req.requestId));
              }
              if (req.id) {
                allInternalRequestIds.add(req.id);
                allInternalRequestIds.add(String(req.id));
              }
            });
          }
        }
        
        // Deduplicate companies by ID before updating state
        const uniqueCompanies = deduplicateCompanies(updatedPlusProject);
        
        // Update PlusProject ONCE after all companies are processed
        setKjuupPlusProjects(uniqueCompanies);
        
        // Aggregate all internal requests and dispatch
        const requestMap = new Map();
        updatedPlusProject.forEach(company => {
          if (company.projectJoinRequests && company.projectJoinRequests.length > 0) {
            company.projectJoinRequests.forEach(request => {
              if (request?.requestId && !requestMap.has(request.requestId)) {
                requestMap.set(request.requestId, request);
              }
            });
          }
        });
        const allInternalRequests = Array.from(requestMap.values());
        console.log('All internal requests:', allInternalRequests.length, 'IDs:', allInternalRequestIds);
        dispatch({ type: SET_JOIN_REQUEST_INTERNAL, requests: allInternalRequests });
        
        // NOW fetch external requests, filtering out any that are internal
        console.log('About to call getProjectJoinRequest with internal IDs:', Array.from(allInternalRequestIds));
        await getProjectJoinRequest(allInternalRequestIds);
      };
      
      fetchAllInternalRequests();
    } else if (PlusProject.length === 0 && !hasInitialFetchedJoinRequests.current) {
      // No internal projects, just fetch external requests
      hasInitialFetchedJoinRequests.current = true;
      getProjectJoinRequest(new Set());
    }
  }, [PlusProject])


  const getInternalJoinRequest = async (cId, index) => {
    const { data } = await callAPI(`/building/getProjectJoinRequest?companyId=${cId}`, {}, "GET");
    console.log('getInternalJoinRequest API response for company', cId, ':', data);
    if (data.status) {
      let req = []
      const internalRequestIds = new Set();
      for (let obj of data.requests) {
        let x = { ...obj, cId }
        req.push(x)
        // Add both requestId and id to handle different field names
        if (obj.requestId) {
          internalRequestIds.add(obj.requestId);
          internalRequestIds.add(String(obj.requestId));
        }
        if (obj.id) {
          internalRequestIds.add(obj.id);
          internalRequestIds.add(String(obj.id));
        }
      }
      let tmp = [...PlusProject]
      tmp[index].projectJoinRequests = [...req]
      setKjuupPlusProjects(tmp)
      
      // Also update Redux joinRequestsInternal by aggregating all company requests
      const requestMap = new Map();
      tmp.forEach(company => {
        if (company.projectJoinRequests && company.projectJoinRequests.length > 0) {
          company.projectJoinRequests.forEach(request => {
            const key = request?.requestId || request?.id;
            if (key && !requestMap.has(key)) {
              requestMap.set(key, request);
              if (request.requestId) {
                internalRequestIds.add(request.requestId);
                internalRequestIds.add(String(request.requestId));
              }
              if (request.id) {
                internalRequestIds.add(request.id);
                internalRequestIds.add(String(request.id));
              }
            }
          });
        }
      });
      const allInternalRequests = Array.from(requestMap.values());
      console.log('Internal requests after aggregation:', allInternalRequests.length);
      dispatch({ type: SET_JOIN_REQUEST_INTERNAL, requests: allInternalRequests });
      
      // No need to refresh external requests when switching company tabs
      // External requests are fetched once during initial load
    }
  };


  useEffect(() => {
    if (!value) {
      props.changeBorder(KJUUP_COLORS.base_color)
    }
    else {
      props.changeBorder(KJUUP_COLORS.internal)
    }
  }, [value])
  useEffect(() => {
    setInternalProjects([...internalProjectsAll])
  }, [internalProjectsAll])

  useEffect(() => {
    props.changeBorder(!props.isExternalSelected ? KJUUP_COLORS.base_color : KJUUP_COLORS.internal)
    setValue(props.isExternalSelected)
  }, [props.isExternalSelected])


  useEffect(() => {
    if (props.projects.length < 1) {
      // getProjects();
    } else {
      setProjects(props.projects);
      setAllProject(props.projects);
    }
  }, [props.projects]);



  useEffect(() => {
    if (props.updateProjectActionFire) {
      props.updateProjectAction(false);
      if (skipNextRoomRefreshRef.current) {
        skipNextRoomRefreshRef.current = false;
        return;
      }
      let ind = PlusProject.findIndex(e => e?.isSelected)
      getKjuupPlusProjects(ind)
      getProjects();
    }
  }, [props.updateProjectActionFire]);


  const getProjectName = (name) => getAvatarInitials(name);
  //Handle Re-Join project
  const handleJoin = async (project) => {
    await $crud.confirm({
      title: "",
      textContent: isGerm ? `Wollen Sie dem Projekt ${project.name} wirklich wieder beitreten?` : `Do you really want to re-join the project ${project.name}?`,
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    if (companies.length > 1) {
      await setParam("id", project.id);
      setCompanyDialog(true);
    } else if (companies.length === 1) {
      await submitReJoinSingleCompany(project.id, companies[0].id);
    } else {
      await submitReJoinWithoutCompany(project.id);
    }
  };


  //Handle Re-Join project Internal
  const handleJoinInternal = async (project, id) => {
    await $crud.confirm({
      title: "",
      textContent: isGerm ? `Wollen Sie dem Projekt ${project.name} wirklich wieder beitreten?` : `Do you really want to re-join the project ${project.name}?`,
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    await submitReJoinSingleCompany(project.id, id);
  };


  const submitReJoinSingleCompany = async (project_id, companyId) => {
    const { data } = await callAPI(
      `/building/${params.id ? params.id : project_id}/join`,
      {
        id: project_id,
        companyId: companyId,
      },
      "PUT"
    );
    if (data.status) {
      $crud.notify({
        type: data.status,
        message: data.message,
      });
      const updateProjectList = props.openProjects.map((project) => {
        return project.id === params.id
          ? { ...project, isJoin: true }
          : project;
      });
      props.updateOpenProjects(updateProjectList);
      props.updateProjectAction(true);
      let ind = PlusProject.findIndex(e => e.isSelected)
      getKjuupPlusProjects(ind)
      getProjects();
    }
  };

  //Submit RE-join request
  const submitReJoinCompany = async (company) => {
    const { data } = await callAPI(
      `/building/${params.id}/join`,
      {
        id: params.id,
        companyId: company.id,
      },
      "PUT"
    );
    if (data.status) {
      $crud.notify({
        type: data.status,
        message: data.message,
      });
      const updateProjectList = props.openProjects.map((project) => {
        return project.id === params.id
          ? { ...project, isJoin: true }
          : project;
      });
      props.updateOpenProjects(updateProjectList);
      props.updateProjectAction(true);
      getProjects();
    }
  };
  //Submit RE-join request without company
  const submitReJoinWithoutCompany = async (id) => {
    const { data } = await callAPI(`/building/${id}/join`, {}, "PUT");
    if (data.status) {
      $crud.notify({
        type: data.status,
        message: data.message,
      });
      const updateProjectList = props.openProjects.map((project) => {
        return project.id === params.id
          ? { ...project, isJoin: true }
          : project;
      });
      props.updateOpenProjects(updateProjectList);
      props.updateProjectAction(true);
      getProjects();
    }
  };

  //Search Project
  const searchProject = async (e) => {
    console.log("Search is called")
    const value = e;
    setSearch(value);
    const searchResult = await allProjects.filter((project) => {
      if (value === "") {
        return project;
      } else if (
        project.name?.toLowerCase().includes(value.trim()?.toLowerCase())
        || project.originalName?.toLowerCase().includes(value.trim()?.toLowerCase())
        || project.translatedName?.toLowerCase().includes(value.trim()?.toLowerCase())
      ) {
        return project;
      }
    });
    if (value === "") {
      setProjects(allProjects);
    } else {
      setProjects(searchResult);
    }
  };


  //Search Kjup plust Projects
  const searchKjuupPlusProject = async (e) => {
    console.log("Search is called")
    const value = e.trim();
    setSearch(value);
    let tmp = [...PlusProject]
    let ind = PlusProject.findIndex(e => e.isSelected)
    let projs = PlusProject[ind].userProjectList
    const searchResult = await projs.filter((project) => {
      if (value === "") {
        return project;
      } else if (
        project.name?.toLowerCase().includes(value?.toLowerCase())
        || project.originalName?.toLowerCase().includes(value?.toLowerCase())
        || project.translatedName?.toLowerCase().includes(value?.toLowerCase())
      ) {
        return project;
      }
    });
    if (value === "") {
      setKjuupPlusProjects(PlusProjectAll);
    } else {
      tmp[ind] = { ...tmp[ind], userProjectList: [...searchResult] }
      setKjuupPlusProjects(tmp);
    }
  };

  // Open Add User to Project Window
  const addUserToProject = (project) => {
    let ind = -1;
    if (shouldShowTabWise && value == 0) {
      ind = PlusProject.findIndex(e => e.isSelected)
    }
    if (!project.isOpened) {
      const chk = props.openProjects.find((p) => p.id === project.id);
      if (chk) {
        const filteredProject = props.openProjects.filter(
          (p) => p.id !== project.id
        );
        const proj = { ...filteredProject, openAddProjectWindow: true, addAsMember: true };
        props.updateOpenProjects(proj);
      } else {
        props.updateOpenProjects([
          ...props.openProjects,
          { ...project, openAddProjectWindow: true, addAsMember: true },
        ]);
      }
    }
  };

  const handleUpdateRequests = (id, cid, index) => {
    console.log('------->update', id, cid, index)
    if (cid) {
      const updatedRequestsInt = pendingRequestsPlus.filter(
        (req) => req.requestId !== id
      );
      if (updatedRequestsInt.length == 0) {
        setPlusNotifications(false)
      }
      dispatch({ type: SET_JOIN_REQUEST_INTERNAL, requests: updatedRequestsInt })
      let a = { ...unSeenAllCount }
      let f = { ...a, unseenBuildingChatCount: (a.unseenBuildingChatCount - 1) < 0 ? 0 : a.unseenBuildingChatCount - 1, unseenInternalProject: (a.unseenInternalProject - 1) < 0 ? 0 : a.unseenInternalProject - 1 }
      props.updateAllBadgeCount(f);
      let ind = PlusProject.findIndex(e => e.isSelected)
      getKjuupPlusProjects(ind)
      if (ind !== -1) {
        let tmp = [...PlusProject]
        tmp[ind].projectJoinRequests = [...updatedRequestsInt]
        setKjuupPlusProjects([...tmp])
      }
    }
    else {
      const updatedRequests = pendingRequests.filter(
        (req) => req.requestId !== id
      );
      if (updatedRequests.length == 0) {
        setNotification(false)
      }
      dispatch({ type: SET_JOIN_REQUEST_EXTERNAL, requests: updatedRequests })
      props.updateProjectRequestCount(updatedRequests.length);
      let a = { ...unSeenAllCount }
      let f = { ...a, unseenBuildingChatCount: (a.unseenBuildingChatCount - 1) < 0 ? 0 : a.unseenBuildingChatCount - 1, unseenExternalProject: (a.unseenExternalProject - 1) < 0 ? 0 : a.unseenExternalProject - 1 }
      props.updateAllBadgeCount(f);
      getProjects();
    }
  };



  useEffect(() => {
    setValue(props.isExternalSelected)
    setOversight(false)
  }, [props.isExternalSelected])

  const adminCompanies = (companies || []).filter(managesCompanyRooms)
  const oversightCompany =
    adminCompanies.find(c => String(c.id) === String(oversightCompanyId)) ||
    adminCompanies.find(c => String(c.id) === String(selectedCompanyId)) ||
    adminCompanies[0] ||
    null
  const showOversight = oversight && !!oversightCompany
  const oversightRoom = useSelector(state => state.oversightRoom)

  // The room column only shows an oversight room while its list is on screen.
  const oversightListCompanyId = showOversight ? oversightCompany.id : null
  useEffect(() => {
    if (!oversightRoom) return
    if (oversightListCompanyId == null || String(oversightRoom.companyId) !== String(oversightListCompanyId)) {
      dispatch({ type: SET_OVERSIGHT_ROOM, payload: null })
    }
  }, [oversightListCompanyId, oversightRoom, dispatch])

  const openOversightRoom = (room) => {
    if (!oversightCompany || !room) return
    props.updateOpenProjects([])
    dispatch({
      type: SET_OVERSIGHT_ROOM,
      payload: {
        id: String(room.id),
        name: room.name || "",
        isInternal: !!room.isInternal,
        companyId: oversightCompany.id,
        companyName: oversightCompany.name,
      },
    })
  }

  // The oversight list and "All" filter on the header search alone, so their
  // query never carries over to the Extern/Intern lists (or the other way round).
  const resetSearch = () => {
    if (!search) return
    if (showAll) {
      setSearch("")
    } else if (value == 1) {
      if (PlusProject.length) searchKjuupPlusProject("")
      else setSearch("")
    } else {
      searchProject("")
    }
  }

  // "+" on Oversight: an internal room of that company when the viewer has
  // internal rooms there, otherwise the regular room creation.
  const addOversightRoom = () => {
    const plusCompany = PlusProject.find(c => String(c.id) === String(oversightCompany?.id) && !c.isLeave)
    if (plusCompany) {
      setShowAddProject({ from: "internal", companyId: plusCompany.id, companyName: plusCompany.name, projects: plusCompany.userProjectList || [] })
    } else {
      setShowAddProject(true)
    }
  }

  const handleChange = (newValue) => {
    if (newValue === ALL_TAB) {
      if (showAll) return
      resetSearch()
      setOversight(false)
      setShowAll(true)
      props.changeBorder(KJUUP_COLORS.base_color)
      return
    }
    if (showAll) {
      // The combined list filters on `search` alone; the filtered lists start clean.
      setShowAll(false)
      setSearch("")
    }
    if (newValue === OVERSIGHT_TAB) {
      if (!oversight) resetSearch()
      props.updateOpenProjects([])
      setOversight(true)
      return
    }
    if (oversight) resetSearch()
    setOversight(false)
    props.updateOpenProjects([])
    props.changeTab(newValue)
    setValue(newValue)
    if (newValue == 0)
      props.changeBorder(KJUUP_COLORS.base_color)
    else
      props.changeBorder(KJUUP_COLORS.internal)
  }

  useEffect(() => {
    if (value == 1) {
      if (PlusProject && PlusProject.length > 0) {
        let ind = PlusProject.findIndex(e => e.isSelected)
        if (ind !== -1) {
          dispatch({ type: SET_COMPANY_IMAGE, payload: { logo: PlusProject[ind].logo, name: PlusProject[ind].name } })
        }
        else {
          dispatch({ type: SET_COMPANY_IMAGE, payload: { logo: PlusProject[0].logo, name: PlusProject[0].name } })
        }
      }
    }
    else {
      dispatch({ type: SET_COMPANY_IMAGE, payload: null })
    }
  }, [value])


  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } =
      React.useContext(VisibilityContext);

    return (
      <div className="tt-l mr-2" disabled={isFirstItemVisible} onClick={() => scrollPrev()}>
        {isFirstItemVisible ?
          // <img
          //   width={10} src={process.env.PUBLIC_URL + "assets/img/Arrow Left-deselected.svg"} alt="Generic placeholder"
          // />
          <BsChevronLeft size={'20px'} color={"#DFDFDF"} />
          :
          <BsChevronLeft size={'20px'} color={KJUUP_COLORS.internal} />
          // <img width={10} src={process.env.PUBLIC_URL + "assets/img/backx.svg"} alt="Generic placeholder" />
        }
      </div>
    );
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

    return (
      <div className="tt-l ml-2" disabled={isLastItemVisible} onClick={() => scrollNext()}>
        {isLastItemVisible ?
          // <img
          //   width={10} src={process.env.PUBLIC_URL + "assets/img/arrow-rightdeselected.svg"} alt="Generic placeholder"
          // />
          <BsChevronRight size={'20px'} color={"#DFDFDF"} />
          :
          <BsChevronRight size={'20px'} color={KJUUP_COLORS.internal} />
        }
      </div>
    );
  }

  const _onCompanyPress = (index, id) => {
    // No longer need to scroll since CompanySelector uses button layout
    let tmp = deduplicateCompanies([...PlusProject])
    for (let i = 0; i < tmp.length; i++) {
      if (i == index) {
        if (tmp[i].isLeave) {
          dispatch({ type: SET_COMPANY_IMAGE, payload: null })
        }
        else
          dispatch({ type: SET_COMPANY_IMAGE, payload: { logo: tmp[i].logo, name: tmp[i].name } })
        dispatch({ type: SET_COMPANY_ID, payload: tmp[i].id })
        tmp[i].isSelected = true
      }
      else {
        tmp[i].isSelected = false
      }
    }
    setKjuupPlusProjects(tmp)
    getInternalJoinRequest(id, index)
  }

  const apiRef = React.useRef();

  const openToggleProject = useSelector(state => state.openToggleProject);

  // Skeleton loading component for rooms
  const renderRoomsSkeleton = () => (
    <div className={`scroll latestmessages_scrollbar loading ${!showSkeleton ? 'skeleton-fade-out' : ''} my-project__skeleton${showSkeleton ? '' : ' my-project__skeleton--hidden'}`}>
      {/* Skeleton Room Items */}
      {[1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => (
        <div key={item} className="company_services m-0 chat_services user_info_chat left_users p-1 my-project__skeleton-item"
          style={{ '--skeleton-delay': `${index * 0.05}s` }}>
          <div className="company_centact my-project__skeleton-row">
            <div className="skeleton skeleton-image my-project__skeleton-image"></div>
            <div className="my-project__skeleton-lines">
              <div className="skeleton skeleton-text my-project__skeleton-line"></div>
              <div className="skeleton skeleton-text short my-project__skeleton-line--short"></div>
            </div>
            <div className="my-project__skeleton-action">
              <div className="skeleton skeleton-icon my-project__skeleton-icon"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const _renderProjects = () => {
    // Show skeleton loader while loading
    if (isLoading || showSkeleton) {
      return renderRoomsSkeleton();
    }

    // Find selected company
    const selectedCompanyObj = PlusProject.find(c => c.isSelected);
    const rawUserProjectList = selectedCompanyObj?.userProjectList || [];

    // Defensive dedup by room id: the backend can return more than one membership
    // row for the same building (repeated join/leave/invite cycles), which would
    // otherwise render the same room multiple times in the internal list.
    const seenRoomIds = new Set();
    const userProjectList = rawUserProjectList.filter(item => {
      if (item == null || item.id == null) return true;
      const key = item.id.toString();
      if (seenRoomIds.has(key)) return false;
      seenRoomIds.add(key);
      return true;
    });

    // Separate rooms by status for the selected company; pinned rooms first,
    // then by last activity
    const activeRooms = orderActiveRooms(userProjectList.filter(item => item.isJoin && !item.isDone), pinnedRooms);
    const deactivatedRooms = sortByActivity(userProjectList.filter(item => !item.isJoin && !item.isDone));
    const completedRooms = sortByActivity(userProjectList.filter(item => item.isDone));

    // Flattened list with headers and items, only show items if expanded
    const flatRoomList = [];
    [
      { key: 'active', title: 'Active projects', items: activeRooms },
      { key: ROOM_SECTION_KEYS.DEACTIVATED, title: strings.deactivated_rooms, items: deactivatedRooms },
      { key: ROOM_SECTION_KEYS.COMPLETED, title: strings.completed_rooms, items: completedRooms },
    ].forEach(section => {
      if (section.items.length > 0) {
        if (section.key === 'active') {
          flatRoomList.push(...section.items.map(item => ({ ...item, type: 'item' })));
        } else {
          flatRoomList.push({
            type: 'header',
            title: section.title,
            sectionKey: section.key,
            badgeCount: sectionUnread(section.items),
          });
          if (expandedSectionsInternal[section.key]) {
            flatRoomList.push(...section.items.map(item => ({ ...item, type: 'item' })));
          }
        }
      }
    });

    return (
      !plusNotifications ?
        <div
          className={`my_project px-2 pt-0 p-0 m-0 immoanimation-enter-done border-radius-0 project_list_div ${isContentReady ? 'company-content-fade-in' : ''} my-project__list ${props.isOpenByOwner ? 'my-project__list--owner my-project__list--owner-tint' : `my-project__list--member my-project__list--border-0${showSkeleton ? ' my-project__list--loading' : ''}`}${(!isDesktop && openToggleProject) ? ' my-project__list--hidden' : ''}`}
        >
          {/* CompanySelector is now rendered in the header when there are multiple companies */}
          <div>
            {
              PlusProject.map((item, index) => {
                return (
                  item.isSelected && !item.isLeave &&
                  <>
                    {item.projectJoinRequests && item.projectJoinRequests.length > 0 ?
                      <div className="kj-flex-1">
                        <InvitationProjectsCard isInternal onClick={() => {
                          setPendingRequestsPlus(item.projectJoinRequests)
                          setPlusNotifications(true)
                        }} pendingRequests={item.projectJoinRequests.length} />
                      </div>
                      :
                      <></>
                    }
                  </>
                )
              })
            }
          </div>
          <div className="datalist_div kj-flex-1">
            {
              PlusProject.map((mainItem, mainIndex) => {
                return (
                  mainItem.isSelected && mainItem.userProjectList &&
                  <CustomScrollbars
                    autoHide
                    autoHideTimeout={200}
                    autoHideDuration={200}
                    className="bottom-bar"
                  >
                    <div className="my-project__room-list">
                      {flatRoomList.map((item) => {
                        if (item.type === 'header') {
                          const sectionKey = item.sectionKey;
                          const isExpanded = !!expandedSectionsInternal[sectionKey];
                          return (
                            <SectionHeader
                              key={`header-${sectionKey}`}
                              title={item.title}
                              expanded={isExpanded}
                              badgeCount={item.badgeCount}
                              onClick={() => setExpandedSectionsInternal(prev => ({
                                ...prev,
                                [sectionKey]: !prev[sectionKey]
                              }))}
                            />
                          );
                        }
                        // Render your room row (use your existing ProjectListComponentInternal logic)
                        return (
                          <ProjectListComponentInternal
                            key={`room-${item.id}`}
                            projects={[item]}
                            chat_click={(val, projectid) => chat_click_plus(val, projectid, value, mainItem.videoCallEnabled)}
                            addUserToProject={(x) => addUserToProject(x)}
                            handleShow={(x) => handleShow(x)}
                            handleJoin={(x, id) => handleJoinInternal(x, id)}
                            isLeave={mainItem.isLeave}
                            cId={mainItem.id}
                          />
                        );
                      })}
                      {flatRoomList.length === 0 && (
                        <div className="my-project__empty">
                          {isGerm ? 'Keine Projekte verfügbar.' : 'No projects available.'}
                        </div>
                      )}
                    </div>
                  </CustomScrollbars>
                )
              })
            }
          </div>
          <ShareProjectMapDialog
            company={projectDetails}
            show={show}
            handleClose={handleClose}
          />
          {showCompanyDialog && (
            <CompanyListDialog
              handleClose={(e) => setCompanyDialog(false)}
              setParam={setParam}
              companies={companies}
              handleReJoinCompany={submitReJoinCompany}
            />
          )}
        </div>
        :
        <ProjectNotification type={'internal'} updateRequests={handleUpdateRequests} handleClose={() => setPlusNotifications(false)}
          requests={pendingRequestsPlus} />
    )
  }

  const _renderNormalProjects = () => {
    // Show skeleton loader while loading
    if (isLoading || showSkeleton) {
      return renderRoomsSkeleton();
    }

    // Separate rooms by status for external projects; pinned rooms first, then
    // by last activity
    const activeRooms = orderActiveRooms(projects.filter(item => item.isJoin && !item.isDone), pinnedRooms);
    const deactivatedRooms = sortByActivity(projects.filter(item => !item.isJoin && !item.isDone));
    const completedRooms = sortByActivity(projects.filter(item => item.isDone));

    // Flattened list with headers and items, only show items if expanded
    const flatRoomList = [];
    [
      { key: 'active', title: 'Active projects', items: activeRooms },
      { key: ROOM_SECTION_KEYS.DEACTIVATED, title: strings.deactivated_rooms, items: deactivatedRooms },
      { key: ROOM_SECTION_KEYS.COMPLETED, title: strings.completed_rooms, items: completedRooms },
    ].forEach(section => {
      if (section.items.length > 0) {
        if (section.key === 'active') {
          flatRoomList.push(...section.items.map(item => ({ ...item, type: 'item' })));
        } else {
          flatRoomList.push({
            type: 'header',
            title: section.title,
            sectionKey: section.key,
            badgeCount: sectionUnread(section.items),
          });
          if (expandedSections[section.key]) {
            flatRoomList.push(...section.items.map(item => ({ ...item, type: 'item' })));
          }
        }
      }
    });

    return (
      !showNotification ? (
        <div
          className={`my_project px-2 pt-0 p-0 m-0 immoanimation-enter-done border-radius-0 project_list_div ${isContentReady ? 'company-content-fade-in' : ''} my-project__list ${props.isOpenByOwner ? `my-project__list--owner${(!isDesktop && openToggleProject) ? ' my-project__list--hidden' : ''}` : `my-project__list--member ${shouldShowTabWise ? 'my-project__list--border-0' : 'my-project__list--border-2'}${showSkeleton ? ' my-project__list--loading' : ''}`}`}
        >
          {pendingRequests?.length > 0 ?
            <div className="kj-flex-1">
              <InvitationProjectsCard onClick={() => setNotification(true)} pendingRequests={pendingRequests.length} />
            </div>
            :
            <></>
          }
          <CustomScrollbars
            autoHide
            autoHideTimeout={200}
            autoHideDuration={200}
            className="bottom-bar"
            styles={{}}
          >
            <div className="my-project__room-list">
              {flatRoomList.map((item) => {
                if (item.type === 'header') {
                  const sectionKey = item.sectionKey;
                  const isExpanded = !!expandedSections[sectionKey];
                  return (
                    <SectionHeader
                      key={`header-${sectionKey}`}
                      title={item.title}
                      expanded={isExpanded}
                      badgeCount={item.badgeCount}
                      onClick={() => setExpandedSections(prev => ({
                        ...prev,
                        [sectionKey]: !prev[sectionKey]
                      }))}
                    />
                  );
                }
                // Render your room row (use your existing ProjectListComponent logic)
                return (
                  <ProjectListComponent
                    key={`room-${item.id}`}
                    projects={[item]}
                    chat_click={(val, projectid) => chat_click(val, projectid)}
                    addUserToProject={(x) => addUserToProject(x)}
                    handleShow={(x) => handleShow(x)}
                    handleJoin={(x) => handleJoin(x)}
                    onChangePosition={(list) => {
                      setProjects(list)
                    }}
                  />
                );
              })}
              {flatRoomList.length === 0 && (
                <div className="my-project__empty">
                  {isGerm ? 'Keine Projekte verfügbar.' : 'No projects available.'}
                </div>
              )}
            </div>
          </CustomScrollbars>
          <ShareProjectMapDialog
            company={projectDetails}
            show={show}
            handleClose={handleClose}
          />
          {showCompanyDialog && (
            <CompanyListDialog
              handleClose={(e) => setCompanyDialog(false)}
              setParam={setParam}
              companies={companies}
              handleReJoinCompany={submitReJoinCompany}
            />
          )}
        </div>
      )
        :
        <ProjectNotification updateRequests={handleUpdateRequests} handleClose={() => setNotification(false)}
          requests={pendingRequests} />
    )
  }

  // "All": external and internal rooms in one list — pinned first, then by
  // last activity. Each row opens and re-joins through its own kind.
  const _renderAllProjects = () => {
    if (isLoading || showSkeleton) {
      return renderRoomsSkeleton();
    }
    if (showNotification) {
      return (
        <ProjectNotification updateRequests={handleUpdateRequests} handleClose={() => setNotification(false)}
          requests={pendingRequests} />
      );
    }
    if (plusNotifications) {
      return (
        <ProjectNotification type={'internal'} updateRequests={handleUpdateRequests} handleClose={() => setPlusNotifications(false)}
          requests={pendingRequestsPlus} />
      );
    }

    const q = search.trim().toLowerCase();
    // One list of every room (no Extern / Intern filter); internal ones carry a tag.
    const rooms = (q
      ? allRooms.filter((room) =>
        room.name?.toLowerCase().includes(q)
        || room.originalName?.toLowerCase().includes(q)
        || room.translatedName?.toLowerCase().includes(q))
      : allRooms
    ).map((room) => (room.listKind === "internal" ? { ...room, listTag: strings.internal_project } : room));

    const activeRooms = orderActiveRooms(rooms.filter(item => item.isJoin && !item.isDone), pinnedRooms);
    const deactivatedRooms = sortByActivity(rooms.filter(item => !item.isJoin && !item.isDone));
    const completedRooms = sortByActivity(rooms.filter(item => item.isDone));

    const flatRoomList = activeRooms.map(item => ({ ...item, type: 'item' }));
    [
      { key: ROOM_SECTION_KEYS.DEACTIVATED, title: strings.deactivated_rooms, items: deactivatedRooms },
      { key: ROOM_SECTION_KEYS.COMPLETED, title: strings.completed_rooms, items: completedRooms },
    ].forEach(section => {
      if (section.items.length === 0) return;
      flatRoomList.push({
        type: 'header',
        title: section.title,
        sectionKey: section.key,
        badgeCount: sectionUnread(section.items),
      });
      if (expandedSectionsAll[section.key] || q) {
        flatRoomList.push(...section.items.map(item => ({ ...item, type: 'item' })));
      }
    });

    const internalRequests = Array.isArray(joinRequestsInternal) ? joinRequestsInternal : [];

    return (
      <div
        className={`my_project px-2 pt-0 p-0 m-0 immoanimation-enter-done border-radius-0 project_list_div ${isContentReady ? 'company-content-fade-in' : ''} my-project__list ${props.isOpenByOwner ? `my-project__list--owner${(!isDesktop && openToggleProject) ? ' my-project__list--hidden' : ''}` : 'my-project__list--member my-project__list--border-0'}`}
      >
        {pendingRequests?.length > 0 ? (
          <div className="kj-flex-1">
            <InvitationProjectsCard onClick={() => setNotification(true)} pendingRequests={pendingRequests.length} />
          </div>
        ) : null}
        {internalRequests.length > 0 ? (
          <div className="kj-flex-1">
            <InvitationProjectsCard isInternal onClick={() => {
              setPendingRequestsPlus(internalRequests)
              setPlusNotifications(true)
            }} pendingRequests={internalRequests.length} />
          </div>
        ) : null}
        <CustomScrollbars
          autoHide
          autoHideTimeout={200}
          autoHideDuration={200}
          className="bottom-bar"
        >
          <div className="my-project__room-list">
            {flatRoomList.map((item) => {
              if (item.type === 'header') {
                const sectionKey = item.sectionKey;
                return (
                  <SectionHeader
                    key={`header-${sectionKey}`}
                    title={item.title}
                    expanded={!!expandedSectionsAll[sectionKey] || !!q}
                    badgeCount={item.badgeCount}
                    onClick={() => setExpandedSectionsAll(prev => ({
                      ...prev,
                      [sectionKey]: !prev[sectionKey]
                    }))}
                  />
                );
              }
              if (item.listKind === "internal") {
                const company = item.listCompany || {};
                return (
                  <ProjectListComponentInternal
                    key={`room-${item.id}`}
                    projects={[item]}
                    chat_click={(val, project) => chat_click_plus(val, project, 1, company.videoCallEnabled)}
                    addUserToProject={(x) => addUserToProject(x)}
                    handleShow={(x) => handleShow(x)}
                    handleJoin={(x, id) => handleJoinInternal(x, id)}
                    isLeave={company.isLeave}
                    cId={company.id}
                  />
                );
              }
              return (
                <ProjectListComponent
                  key={`room-${item.id}`}
                  projects={[item]}
                  chat_click={(val, project) => chat_click(val, project)}
                  addUserToProject={(x) => addUserToProject(x)}
                  handleShow={(x) => handleShow(x)}
                  handleJoin={(x) => handleJoin(x)}
                  onChangePosition={() => { }}
                />
              );
            })}
            {flatRoomList.length === 0 && (
              <div className="my-project__empty">
                {isGerm ? 'Keine Projekte verfügbar.' : 'No projects available.'}
              </div>
            )}
          </div>
        </CustomScrollbars>
        <ShareProjectMapDialog
          company={projectDetails}
          show={show}
          handleClose={handleClose}
        />
        {showCompanyDialog && (
          <CompanyListDialog
            handleClose={(e) => setCompanyDialog(false)}
            setParam={setParam}
            companies={companies}
            handleReJoinCompany={submitReJoinCompany}
          />
        )}
      </div>
    )
  }

  const isDeskTopResolution = useSelector(e => e.isDeskTopResolution);

  // Company admins get the Oversight tab even without internal rooms
  // ("Räume · Verwaltung", as in the mobile app).
  const hasOversightTab = adminCompanies.length > 0 || (!companiesLoaded && !!roomTabsHint.oversight)
  const showInternalTab = shouldShowTabWise
  const internalSelected = value == 1 && showInternalTab && !showAll

  return (
    <React.Fragment>
      {!shouldShowTabWise && !hasOversightTab ? (
        <div
          className="w-300 my_project pt-0 p-0  m-0 immoanimation-enter-done border-radius-0 common_box_user_list my-project__panel"
          // style={{ flex: 1, height: 'var(--app-height)', display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, border: 'none'}}
          >
          <CommonHeader
            hideTab={true}
            filterTabs
            value={value}
            onChange={(val) => handleChange(val)}
            isGerm={isGerm}
            searchQuery={search}
            searchPlaceholder={strings.search_rooms}
            onSearch={(val) => {
              if (value == 0)
                searchProject(val)
              else
                searchKjuupPlusProject(val)
            }}
            showPlus={true}
            onAddClick={() => {
              props.updateOpenProjects([])
              setShowAddProject(true)
            }}
          />
          {_renderNormalProjects()}
          {showAddProject && (
            <AddProject
              closePage={() => setShowAddProject(false)}
              data={showAddProject}
              isInternal={showAddProject?.from === "internal"}
            />
          )}
        </div>
      ) :
        <div
          className={`w-300 my_project pt-0 p-0  m-0 immoanimation-enter-done border-radius-0 common_box_user_list my-project__panel my-project__panel--borderless${props.isOpenByOwner ? " my-project__panel--owner" : ""}`}
          // style={props.isOpenByOwner ?
          //   { pointerEvents: "none", opacity: "0.2", height: "var(--app-height)", flex: 1, borderColor: value == 1 ? "var(--kjuup-internal)" : "var(--kjuup-accent)", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, border: 'none' } :
          //   { flex: 1, height:"var(--app-height)", display: "flex", flexDirection: "column", overflow: "hidden", borderRadius: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, border: 'none' }
          // }
        >
          {/* Positioned so the z-index actually applies. The room list below is
              position:relative, and a positioned sibling paints over a static
              one whatever the DOM order — which put the list on top of this
              header and swallowed clicks on the company chips. */}
          <div className="my-project__header">
            <div className="page-header my-project__title">
              <h2 className="page-header-title">{strings.nav_all_rooms}</h2>
            </div>
            <div>
              <CommonHeader
                filterTabs
                value={showOversight ? OVERSIGHT_TAB : showAll ? ALL_TAB : internalSelected ? 1 : 0}
                onChange={(val) => handleChange(val)}
                isGerm={isGerm}
                searchQuery={search}
                searchPlaceholder={strings.search_rooms}
                onSearch={(val) => {
                  if (showOversight || showAll)
                    setSearch(val)
                  else if (!internalSelected)
                    searchProject(val)
                  else
                    searchKjuupPlusProject(val)
                }}
                showPlus={showOversight || !internalSelected ? true :
                  PlusProject.findIndex(e => e.isSelected) !== -1 ? PlusProject[PlusProject.findIndex(e => e.isSelected)].isLeave ? false : true : false
                }
                onAddClick={() => {
                  // props.handleDrawer(true);
                  props.updateOpenProjects([])
                  if (showOversight) {
                    addOversightRoom()
                  }
                  else if (internalSelected) {
                    let mainIndex = PlusProject.findIndex(e => e.isSelected)
                    let item = PlusProject[mainIndex]
                    console.log('------------->', item)
                    setShowAddProject({ from: "internal", companyId: item.id, companyName: item.name, projects: item.userProjectList })
                    // history.push(
                    //   {
                    //     pathname: '/add-project',
                    //     state: { from: "internal", companyId: item.id, companyName: item.name, projects: item.userProjectList }
                    //   })
                  }
                  else {
                    setShowAddProject(true)
                    // history.push({
                    //   pathname: `/add-project`,
                    // });
                  }
                }}
                joinRequestsExternalCount={(() => {
                  if (!Array.isArray(joinRequestsExternal)) return 0;
                  // Deduplicate by requestId within the external array itself
                  const uniqueRequestIds = new Set(
                    joinRequestsExternal
                      .map(req => req?.requestId)
                      .filter(Boolean)
                  );
                  return Math.max(0, uniqueRequestIds.size);
                })()}
                joinRequestsInternalCount={(() => {
                  if (!Array.isArray(joinRequestsInternal)) return 0;
                  // Deduplicate by requestId within the internal array itself
                  const uniqueRequestIds = new Set(
                    joinRequestsInternal
                      .map(req => req?.requestId)
                      .filter(Boolean)
                  );
                  return Math.max(0, uniqueRequestIds.size);
                })()}
                // "All" alone needs no tab row.
                hideTab={!hasOversightTab}
                showOversightTab={hasOversightTab}
                showAllTab
                showInternalTab={false}
                showExternalTab={false}
                companySelector={showOversight ? (
                  // Like the mobile company filter: only with more than one company.
                  adminCompanies.length > 1 ? (
                    <CompanySelector
                      companies={adminCompanies.map(c => ({ ...c, isSelected: c.id === oversightCompany.id }))}
                      onSelect={(_, id) => setOversightCompanyId(id)}
                      unseenArticleByCompany={{}}
                    />
                  ) : null
                ) : PlusProject.length > 1 ? (
                  <CompanySelector
                    companies={PlusProject}
                    onSelect={_onCompanyPress}
                    apiRef={apiRef}
                    showArrows={PlusProject.length > 2}
                    showDailyBriefingCounters={showDailyBriefingCounters}
                  />
                ) : null}
              />
            </div>
          </div>
          <div className="my-project__body">
            {
              showOversight ?
                <OversightRoomList
                  key={String(oversightCompany.id)}
                  companyId={oversightCompany.id}
                  query={search}
                  activeRoomId={oversightRoom ? oversightRoom.id : null}
                  onOpenRoom={openOversightRoom}
                  onRoomsChanged={() => { if (shouldShowTabWise) getKjuupPlusProjects() }}
                />
                :
              showAll ?
                _renderAllProjects()
                :
              internalSelected ?
                _renderProjects()
                :
                _renderNormalProjects()
            }
          </div>
          {showAddProject && (
            <AddProject
              closePage={() => setShowAddProject(false)}
              data={showAddProject}
              isInternal={showAddProject?.from === "internal"}
            />
          )}
        </div>
      }
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const {
    projects,
    openProjects = [],
    updateProjectActionFire,
    openBottomProjects = [],
    projectRequestCount,
    isOpenByOwner,
    isExternalSelected,
    resetProjectMarking
  } = state;
  return {
    projects: projects,
    updateProjectActionFire: updateProjectActionFire,
    openProjects: openProjects,
    openBottomProjects: openBottomProjects,
    projectRequestCount: projectRequestCount,
    isOpenByOwner: isOpenByOwner,
    isExternalSelected,
    resetProjectMarking
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetMarking: (e) =>
      dispatch({ type: RESET_MARKIN_PROJECT, status: e }),
    updateProjects: (projects) =>
      dispatch({ type: PROJECTS, projects: projects }),
    updateProjectsInternal: (projects) =>
      dispatch({ type: INTERNAL_PROJECTS, projects: projects }),
    updateOpenProjects: (projects) =>
      dispatch({ type: OPEN_PROJECTS, openProjects: projects }),
    updateProjectAction: (value) =>
      dispatch({
        type: UPDATE_PROJECT_ACTION_FIRE,
        updateProjectActionFire: value,
      }),
    updateBottomOpenProjects: (projects) =>
      dispatch({ type: OPEN_BOTTOM_PROJECTS, openBottomProjects: projects }),
    updateProjectRequestCount: (count) =>
      dispatch({ type: PROJECT_REQUEST_COUNT, projectRequestCount: count }),
    isOwnerOpenProject: (open) => dispatch({ type: IS_OPEN_BY_OWNER, open }),
    handleDrawer: (open) => dispatch({ type: TOGGLE_DRAWER, open }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
    changeTab: (status) => dispatch({ type: SET_TAB, status: status }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(memo(MyProject)));
